import { Delete } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { User } from "../types";

interface UserDeleteModalProps {
    user: User;
    open: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    loading: boolean;
}

export default function UserDeleteModal({ user, open, handleClose, onConfirm, loading }: UserDeleteModalProps) {
    return (
        <React.Fragment>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Delete User</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You are about to delete <strong>{user.email}</strong>. Are you sure?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" startIcon={<Delete />} color="error" loading={loading} onClick={onConfirm}>
                        Delete
                    </Button>
                    <Button variant="contained" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    )
}